import { useState } from 'react';
import { Modal } from '../components/Modal';
import { Button } from '../components/Button';
import { OppSearchBox } from '../components/sow/OppSearchBox';
import { SOW_TEMPLATE_LABELS, sowEditorUrl } from '../lib/sow';
import type { SowOpportunityHit, SowTemplateType } from '../types';

export function NewSowModal({ onClose, onContinue }: { onClose(): void; onContinue(url: string): void }): JSX.Element {
  const [template, setTemplate] = useState<SowTemplateType | ''>('');
  const [opportunity, setOpportunity] = useState<SowOpportunityHit | null>(null);
  return <Modal onClose={onClose} size="md">
    <div role="dialog" aria-modal="true" aria-labelledby="new-sow-title">
      <div className="modal-hd"><h2 id="new-sow-title">Generate new SOW</h2></div>
      <div className="modal-bd" style={{ display: 'grid', gap: 16 }}>
        <label className="input-label" style={{ display: 'grid', gap: 6 }}>Document type
          <select autoFocus className="select" value={template} onChange={(e) => setTemplate(e.target.value as SowTemplateType)}>
            <option value="">Choose a document type…</option>
            {Object.entries(SOW_TEMPLATE_LABELS).map(([key, label]) => <option key={key} value={key}>{label}</option>)}
          </select>
        </label>
        {template === 'executive_partner_sow' && <div className="banner warn">Executive Partner is awaiting Danielle’s review. Verify fees and fields before use.</div>}
        <div><div className="input-label">Opportunity</div><OppSearchBox onSelect={setOpportunity} onQueryChange={() => setOpportunity(null)} /></div>
        {opportunity && <div className="d-meta">Selected: {opportunity.number} · {opportunity.name} · {opportunity.accountName}</div>}
      </div>
      <div className="modal-foot">
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="primary" disabled={!template || !opportunity} onClick={() => { if (template && opportunity) onContinue(sowEditorUrl(opportunity.id, template)); }}>Continue to editor</Button>
      </div>
    </div>
  </Modal>;
}
